import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  RemoveCircleOutline as RemoveCircleOutlineIcon,
  Update as UpdateIcon
} from "@mui/icons-material";
import {
  Box,
  Button,
  Collapse,
  FilledInput,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useBudgetFormContext } from "../../../context/BudgetFormContext";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#082B49",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableCellBF = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#000000",
    position: "relative"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#F4F6F8",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HeadColumn = ({ title, subTitle, align }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: align,
      flexDirection: "column",
      alignItems: align,
    }}
  >
    <span
      style={{
        fontWeight: 700,
        fontSize: 14,
        color: "#ffff",
        lineHeight: 1,
      }}
    >
      {title}
    </span>
    {subTitle && (
      <span
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: "#ffff",
        }}
      >
        {subTitle}
      </span>
    )}
  </Box>
);

const HeadColumnBF = ({ title, subTitle, align }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: align,
      flexDirection: "column",
      alignItems: align,
    }}
  >
    <span
      style={{
        fontWeight: 700,
        fontSize: 14,
        color: "#f9b136",
        lineHeight: 1,
      }}
    >
      {title}
    </span>
    {subTitle && (
      <span
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: "#f9b136",
        }}
      >
        {subTitle}
      </span>
    )}
  </Box>
);

const format = (price) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(price);

const FormSelection = () => {
  const { selectedPrices, selectedPricesOut, handleAddPriceOut, handleRemovePriceOut, budgets, addToBudget, setExtras, defaultDiscount, nonRefundableDiscount, nonRefundableDiscountPix, nonRefundableDiscountCard, setDiscountInput, setPercDiscount } =
    useBudgetFormContext();
  const [open, setOpen] = useState(true);
  const [flightTax, setFlight] = useState(0);
  const [boardingTax, setBoardingTax] = useState(0);
  const [transferTax, setTransferTax] = useState(0);
  const [additionalTax, setAdditionalTax] = useState(0);
  const [totalExtras, setTotalExtras] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [percDiscount, setPercDiscountLocal] = useState(0);

  const [percDiscountInvalid, setPercDiscountInvalid] = useState(false);

  const [selectedItem, setSelectedItem] = useState("");

  const recalculatePrices = (
    flightTax,
    transferTax,
    additionalTax,
    boardingTax,
  ) => {
    setExtras(flightTax + transferTax + additionalTax + boardingTax);
    setTotalExtras(flightTax + transferTax + additionalTax + boardingTax);
    setDiscountInput(discount);
    setPercDiscount(percDiscount);
  };

  useEffect(() => {
    setAdditionalTax(0);
    setTransferTax(0);
    setBoardingTax(0);
    setFlight(0);
    setExtras(0);
    setTotalExtras(0);

  }, [setExtras]);

  const handleAdd = (accommodation_description) => {
      handleAddPriceOut(accommodation_description);
      setSelectedItem("");
  }

  const handleRemove = (accommodation_description) => {
      handleRemovePriceOut(accommodation_description);
  }

  useEffect(() => {
      if (percDiscount > 0) setDiscount(0);
  }, [percDiscount])

    useEffect(() => {
          if (discount > 0) setPercDiscountLocal(0);
      }, [discount])

  return (
    <Grid container={true} spacing={3} columns={12} sx={{gap: "12px"}}>
      <Grid item size={12}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignContent: "space-between",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                fontSize: 18,
                fontFamily: "Montserrat",
                color: "#082B49",
              }}
            >
              Seleção atual
            </span>
            <span
              style={{
                fontWeight: 600,
                fontSize: 15,
                fontFamily: "Montserrat",
                color: "#868E96",
              }}
            >
              Resumo dos itens selecionados
            </span>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "column",
            }}
          >
            <IconButton onClick={(_) => setOpen(!open)}>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Box>
        </Box>
      </Grid>
      <Grid item size={8}>
        <Collapse in={open}>
          <Table size={"small"}>
            <TableHead>
              {/* <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{ borderBottom: "none" }}
                />
                
                <TableCell
                  colSpan={2}
                  align="center"
                  sx={{
                    background: "#000",
                    position: "relative",
                    padding: 0,
                    borderBottom: "none"
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: 700,
                      fontSize: "14px",
                      color: "#f9b136",
                      padding: "6px 16px",
                      textAlign: "center",
                    }}
                  >
                    BLACK FRIDAY
                  </Box>
                </TableCell>
              </TableRow> */}
              <TableRow>
                <StyledTableCell align={"left"}>
                  <HeadColumn title={"Acomodação"} align={"flex-left"} />
                </StyledTableCell>
                <StyledTableCell align={"right"}>
                  <HeadColumn
                    title={"Total Diárias"}
                    subTitle={"Sem Taxas"}
                    align={"flex-right"}
                  />
                </StyledTableCell>

                  <StyledTableCell align={"right"}>
                  <HeadColumn
                    title={"Total Diárias"}
                    subTitle={"c/ Taxas"}
                    align={"flex-right"}
                  />
                </StyledTableCell>

                  <StyledTableCell align={"right"}>
                  <HeadColumn
                    title={"Total Diárias"}
                    subTitle={"c/ Taxas + Desc. não reembolsável à vista"}
                    align={"flex-right"}
                  />
                </StyledTableCell>

                <StyledTableCell align={"right"}>
                  <HeadColumn
                    title={"Total Diárias"}
                    subTitle={"c/ Taxas + Desc. não reembolsável cartão"}
                    align={"flex-right"}
                  />
                </StyledTableCell>

                {/* <StyledTableCellBF align={"right"}>
                  <HeadColumnBF
                    title={"Total Diárias"}
                    subTitle={"c/ Taxas + Desc. à vista"}
                    align={"flex-right"}
                  />
                </StyledTableCellBF>

                <StyledTableCellBF align={"right"}>
                  <HeadColumnBF
                    title={"Total Pacote"}
                    subTitle={"c/ Taxas cartão"}
                    align={"flex-right"}
                    />
                </StyledTableCellBF> */}

                <StyledTableCell align={"right"}>
                  <HeadColumn
                    title={"Total Pacote"}
                    subTitle={"c/Taxas + extras"}
                    align={"flex-right"}
                    />
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedPrices.map((price) => (
                <StyledTableRow key={price.acommodation_description}>
                  <TableCell sx={{ display: "flex", alignItems: "center", gap: '10px' }}>
                    {price.acommodation_description}
                    {price.flg_nao_disponivel && (
                        <Button
                          onClick={() => handleRemove(price.acommodation_description)}
                          sx={{ minWidth: '25px', padding: 0 }}
                        >
                          <RemoveCircleOutlineIcon sx={{ color: "#FF6B6B" }} />
                        </Button>
                      )
                    }
                  </TableCell>
                  <TableCell align={"right"}>
                    {format(price.total_daily_without_tax)}
                  </TableCell>
                  <TableCell align={"right"}>
                    {format(price.total_daily_with_tax)}
                  </TableCell>
                  <TableCell align={"right"}>
                      <strong>{format(price.total_daily_with_non_refundable_discount_pix)}</strong>
                  </TableCell>
                  <TableCell align={"right"}>
                      <strong>{format(price.total_daily_with_non_refundable_discount_card)}</strong>
                  </TableCell>
                  {/* <TableCell align={"right"}>
                      <strong>{format(price.total_daily_with_tax_discount)}</strong>
                  </TableCell> */}
                  <TableCell align={"right"}>
                      <strong>{format(price.total_cost_accomodation)}</strong>
                  </TableCell>
                </StyledTableRow>
              ))}

              <StyledTableRow>
                <TableCell colSpan={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignContent: "space-between",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: 13,
                        fontFamily: "Montserrat",
                        color: "#ADB5BD",
                      }}
                    >
                      Adicione este item de orçamento a proposta atual
                    </span>
                    <Button
                      sx={{ textTransform: "capitalize", color: "#fff" }}
                      color="fifth"
                      variant="contained"
                      onClick={addToBudget}
                      disabled={
                        selectedPrices.length === 0 || budgets.length === 3
                      }
                    >
                      Adicionar Orçamento
                    </Button>
                  </Box>
                </TableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
		<Box
			sx={{
				m: 1,
				display: "flex",
				alignItems: "center",
				flexDirection: "row",
			}}
		>
			<Select
				value={selectedItem}
				onChange={e => setSelectedItem(e.target.value)}
				displayEmpty
				sx={{
					m: 1,
					display: 'flex',
					alignItems: 'center',
					flexDirection: 'row',
				}}
			>
				<MenuItem value="">
					<span style={{ fontWeight: 600, fontSize: 15, fontFamily: 'Montserrat' }}>
						Selecione uma acomodação
					</span>
				</MenuItem>

				{selectedPricesOut.map(item => (
					<MenuItem
						key={item.acommodation_description}
						value={item.acommodation_description}
					>
						{item.acommodation_description}
					</MenuItem>
				))}
			</Select>

			<Button
				variant="contained"
				onClick={() => handleAdd(selectedItem)}
				disabled={!selectedItem}
			>
				Adicionar selecionado
			</Button>
		</Box>

          <Box
            sx={{
              m: 1,
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <UpdateIcon sx={{ color: "#2F9E44" }} />
            <span
              style={{
                fontWeight: 600,
                fontSize: 15,
                fontFamily: "Montserrat",
                color: "#2F9E44",
              }}
            >
              Atualização automática conforme seleção de itens
            </span>
          </Box>

            <Box
                sx={{
                    m: 1,
                    mt: 3,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <span
                    style={{
                        fontWeight: 600,
                        fontSize: 15,
                        fontFamily: "Montserrat",
                        color: "#000000",
                    }}
                >
                    Desconto de {nonRefundableDiscountCard}% para política Não Reembolsável no cartão de crédito até 10x
                </span>
                <span
                    style={{
                        fontWeight: 600,
                        fontSize: 15,
                        fontFamily: "Montserrat",
                        color: "#000000",
                    }}
                >
                    Desconto de {nonRefundableDiscountPix}% para política Não Reembolsável à vista no PIX
                </span>
                {/* <span
                    style={{
                        fontWeight: 600,
                        fontSize: 15,
                        fontFamily: "Montserrat",
                        color: "#f9b136",
                        background: '#000000',
                        borderRadius: '4px',
                        width: 'fit-content',
                        paddingInline: '2px 2px',
                    }}
                >
                    Desconto de {defaultDiscount}% para pagamento à vista no PIX (Black Friday)
                </span> */}
            </Box>
        </Collapse>
      </Grid>
      <Grid item size={4}>
        <Collapse in={open}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              maxWidth: 400,
            }}
          >
            <FormControl
              fullWidth
              variant="filled"
              style={{ marginBottom: "15px" }}
            >
              <InputLabel htmlFor="flight">Tarifa Aéreo Familia</InputLabel>
              <FilledInput
                id="flight"
                value={flightTax}
                onChange={(e) => setFlight(Number(e.target.value))}
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
              />
            </FormControl>

            <FormControl
              fullWidth
              variant="filled"
              style={{ marginBottom: "15px" }}
            >
              <InputLabel htmlFor="boarding">
                Tarifa Embarque Familia
              </InputLabel>
              <FilledInput
                id="boarding"
                value={boardingTax}
                onChange={(e) => setBoardingTax(Number(e.target.value))}
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
              />
            </FormControl>

            <FormControl
              fullWidth
              variant="filled"
              style={{ marginBottom: "15px" }}
            >
              <InputLabel htmlFor="transfer">Transfer Familia</InputLabel>
              <FilledInput
                id="transfer"
                value={transferTax}
                onChange={(e) => setTransferTax(Number(e.target.value))}
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
              />
            </FormControl>

            <FormControl
              fullWidth
              variant="filled"
              style={{ marginBottom: "15px" }}
            >
              <InputLabel htmlFor="additional">
                Adicionais (requerimento/ingresso/spa)
              </InputLabel>
              <FilledInput
                id="additional"
                value={additionalTax}
                onChange={(e) => setAdditionalTax(Number(e.target.value))}
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
              />
            </FormControl>

            {/*   <FormControl
                  fullWidth
                  variant="filled"
                  style={{ marginBottom: "15px" }}
              >
                  <InputLabel htmlFor="transfer">Valor do Desconto</InputLabel>
                  <FilledInput
                      id="discount"
                      value={discount}
                      onChange={(e) => setDiscount(Number(e.target.value))}
                      startAdornment={
                          <InputAdornment position="start">R$</InputAdornment>
                      }
                  />
            </FormControl> */}

              <FormControl
                  fullWidth
                  variant="filled"
                  style={{ marginBottom: "15px" }}
              >
                  <InputLabel htmlFor="transfer">Percentual de Desconto</InputLabel>
                  <FilledInput
                      id="percDiscount"
                      value={percDiscount}
                      onChange={(e) => {
                        setPercDiscountLocal(Number(e.target.value));
                        if(e.target.value > 50) setPercDiscountInvalid(true);
                          else setPercDiscountInvalid(false);
                      }}
                      error={percDiscountInvalid}
                      startAdornment={
                          <InputAdornment position="start">%</InputAdornment>
                      }
                  />
                    {percDiscountInvalid && (
                      <FormHelperText style={{color: 'red'}}>O percentual máximo permitido é 50%</FormHelperText>
                    )}
              </FormControl>

              <FormControl
                  fullWidth
                  variant="filled"
                  style={{ marginBottom: "15px" }}
              >
                  <InputLabel htmlFor="discount">
                      Total de Extras
                  </InputLabel>
                  <FilledInput
                      id="discount"
                      value={totalExtras || 0}
                      disabled={true}
                      startAdornment={
                          <InputAdornment position="start">R$</InputAdornment>
                      }
                  />
              </FormControl>



              <Button
              color="primary"
              variant="contained"
              disabled={percDiscountInvalid}
              onClick={() => {
                recalculatePrices(
                  flightTax,
                  transferTax,
                  additionalTax,
                  boardingTax,
                );
              }}
            >
              Adicionar extras / desconto
            </Button>
          </Box>
        </Collapse>
      </Grid>
    </Grid>
  );
};

export default FormSelection;
